import type { IntelligentStrategyProps } from "./IntelligentStrategyProps.js";

export const defaultIntelligentStrategyProps: IntelligentStrategyProps = {
  testLockoutPeriodMs: 14 * 24 * 60 * 60 * 1000,
  buckets: 6,
};
